import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  GUIDE_API_URL,
  HELP_CENTER_URL_FAQ,
  LANDING_PAGE_URL,
} from '@src/configs';
import ImportContactsRoundedIcon from '@mui/icons-material/ImportContactsRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CommonButton from '@src/new-components/Button';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { Search as SearchIcon } from '@mui/icons-material';
import { COLOR } from '@src/styles/color';
import SearchInput from '@src/new-components/SearchInput';
import { StyledToolbar } from './index.styled';

const Toolbar = ({
  search,
  handleSearchInputChange,
  onCreateApp,
  apiTtsSttLaunchEnabled,
}) => {
  const { t } = useTranslation();

  return (
    <StyledToolbar
      className={apiTtsSttLaunchEnabled ? 'toolbar-new-api-launch' : ''}
    >
      <div
        className="search-input-container"
        style={{ width: '343px', order: 1 }}
      >
        <SearchInput
          value={search}
          name="search"
          placeholder={t('searchApps')}
          iconStart={
            <SearchIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
          }
          onChange={handleSearchInputChange}
          styleInput={{ paddingLeft: '8px 12px' }}
          className="filter-search-input"
          placeholderStyle={{
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '20px',
            letterSpacing: '-0.4px',
            verticalAlign: 'middle',
            color: COLOR.descriptionGray,
          }}
        />
      </div>
      <div
        className="button-container"
        style={{ display: 'flex', alignItems: 'center', gap: '8px', order: 2 }}
      >
        <CommonButton
          variant="outlined"
          className={apiTtsSttLaunchEnabled ? 'button-faq' : 'button-action'}
          customStyle={{
            padding: '8px',
            borderRadius: '8px',
            height: '40px',
            minWidth: '40px',
            boxSizing: 'border-box',
          }}
          textProps={
            !apiTtsSttLaunchEnabled
              ? { variantText: 'body-14-semibold', color: COLOR.darkBlue }
              : undefined
          }
          onClick={() => window.open(HELP_CENTER_URL_FAQ, '_blank')}
          startIcon={
            !apiTtsSttLaunchEnabled ? (
              <HelpOutlineRoundedIcon
                sx={{ fontSize: '24px', color: COLOR.navyBlue }}
              />
            ) : undefined
          }
        >
          {apiTtsSttLaunchEnabled ? (
            <HelpOutlineRoundedIcon
              sx={{ fontSize: '24px', color: COLOR.navyBlue }}
            />
          ) : (
            t('faq')
          )}
        </CommonButton>

        <CommonButton
          variant="outlined"
          className={apiTtsSttLaunchEnabled ? 'button-flex' : 'button-action'}
          customStyle={{
            padding: '8px 16px',
            borderRadius: '8px',
            height: '40px',
            whiteSpace: 'nowrap',
          }}
          textProps={{
            variantText: 'body-14-semibold',
            color: COLOR.darkBlue,
          }}
          onClick={() => {
            if (apiTtsSttLaunchEnabled) {
              window.open(`${LANDING_PAGE_URL}/api-docs`, '_blank');
            } else {
              window.open(GUIDE_API_URL, '_blank');
            }
          }}
          startIcon={
            <ImportContactsRoundedIcon
              sx={{ fontSize: '24px', color: COLOR.navyBlue }}
            />
          }
        >
          API Docs
        </CommonButton>
        <CommonButton
          variant="contained"
          className={apiTtsSttLaunchEnabled ? 'button-flex' : 'button-action'}
          customStyle={{
            padding: '8px 16px',
            borderRadius: '8px',
            height: '40px',
            whiteSpace: 'nowrap',
          }}
          textProps={{
            variantText: 'body-14-semibold',
            color: COLOR.darkBlue,
          }}
          startIcon={
            <AddRoundedIcon sx={{ fontSize: '24px', color: COLOR.navyBlue }} />
          }
          onClick={onCreateApp}
        >
          {t('createApp')}
        </CommonButton>
      </div>
    </StyledToolbar>
  );
};

export default Toolbar;
